import { render, staticRenderFns } from "./CarPermitModal.vue?vue&type=template&id=adbda230"
import script from "./CarPermitModal.vue?vue&type=script&lang=js"
export * from "./CarPermitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports